import { render } from "./SearchResult.vue?vue&type=template&id=7c68289c"
import script from "./SearchResult.vue?vue&type=script&lang=js"
export * from "./SearchResult.vue?vue&type=script&lang=js"

import exportComponent from "/Users/martin/Coding/work/kraiburg-website-typo3/extensions/dealersearch/Resources/Private/Vue/dealersearch-list/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__